import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LockKeyhole } from "lucide-react";

export const Route = createFileRoute("/_authenticated/convite-aceitar/$token")({
  component: AcceptInviteDisabledPage,
});

function AcceptInviteDisabledPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-6 space-y-4 text-center">
          <div className="mx-auto h-12 w-12 rounded-full bg-muted flex items-center justify-center">
            <LockKeyhole className="h-6 w-6 text-muted-foreground" />
          </div>
          <div className="space-y-2">
            <h1 className="text-xl font-semibold">Convite externo desativado</h1>
            <p className="text-sm text-muted-foreground">
              Use o menu principal do Portal do Usuário para acessar alunos, planos e cobranças.
            </p>
          </div>
          <Button asChild className="w-full">
            <Link to="/dashboard">Abrir menu principal</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}